module.exports = __webpack_public_path__ + "static/media/blogTwo.c2a2759c.webp";